import { Component, input } from '@angular/core';
import type { TechnicalPointCategory } from '../../../../../dashboard/fleet/common/enums/technical-point-category';
import { OrderPointCategory } from '../../../../../dashboard/orders/common/enums/order-point-category';
import { OrderCheckpointFormComponent } from '../../../../../dashboard/orders/order-form/order-points-form/order-checkpoint-form/order-checkpoint-form.component';
import type { OrderPointFormGroup } from '../../../../../dashboard/orders/order-form/order-points-form/order-point-form/order-point-form.component';
import { OrderTransitFormComponent } from '../../../../../dashboard/orders/order-form/order-points-form/order-transit-form/order-transit-form.component';

@Component({
  selector: 'app-route-point-form',
  standalone: true,
  imports: [OrderCheckpointFormComponent, OrderTransitFormComponent],
  templateUrl: './route-point-form.component.html',
  styleUrl: './route-point-form.component.scss',
})
export class RoutePointFormComponent {
  public readonly form = input.required<OrderPointFormGroup>();
  public readonly category = input.required<
    OrderPointCategory | TechnicalPointCategory
  >();
  public readonly disabled = input.required<boolean>();

  protected readonly OrderPointCategory = OrderPointCategory;
}
